var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseLineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.7501H24.5V12.6384C24.5 12.3962 24.4498 12.1566 24.3525 11.9348C24.2551 11.713 24.1128 11.5139 23.9345 11.3499L15.1845 3.09431C15.1803 3.09058 15.1762 3.08656 15.1725 3.08228C14.8503 2.7893 14.4305 2.62695 13.9951 2.62695C13.5596 2.62695 13.1398 2.7893 12.8177 3.08228L12.8056 3.09431L4.06547 11.3499C3.88719 11.5139 3.74487 11.713 3.64754 11.9348C3.5502 12.1566 3.49996 12.3962 3.5 12.6384V22.7501H1.75C1.51794 22.7501 1.29538 22.8423 1.13128 23.0064C0.967187 23.1705 0.875 23.393 0.875 23.6251C0.875 23.8572 0.967187 24.0797 1.13128 24.2438C1.29538 24.4079 1.51794 24.5001 1.75 24.5001H26.25C26.4821 24.5001 26.7046 24.4079 26.8687 24.2438C27.0328 24.0797 27.125 23.8572 27.125 23.6251C27.125 23.393 27.0328 23.1705 26.8687 23.0064C26.7046 22.8423 26.4821 22.7501 26.25 22.7501ZM16.625 22.7501H11.375V17.5001C11.375 17.268 11.4672 17.0455 11.6313 16.8814C11.7954 16.7173 12.0179 16.6251 12.25 16.6251H15.75C15.9821 16.6251 16.2046 16.7173 16.3687 16.8814C16.5328 17.0455 16.625 17.268 16.625 17.5001V22.7501Z",
    fill: "#06BAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseLineActive);
export default __webpack_public_path__ + "static/media/HouseLineActive.86dd3d9322396082ab44932ad2501cf3.svg";
export { ForwardRef as ReactComponent };